export default {
  methods: {
    calculateFilterValues(activeFilters, filterType, newValue, multiselect = false) {
      const currentFilterValue = activeFilters?.[filterType];
      let newFilterValue;

      if (multiselect) {
        if (newValue === null || (Array.isArray(newValue) && newValue.length === 0)) {
          newFilterValue = null;
        } else if (Array.isArray(newValue)) {
          const combinedValues = new Set();

          if (Array.isArray(currentFilterValue)) {
            currentFilterValue.forEach(item => combinedValues.add(item));
          } else if (currentFilterValue !== null) {
            combinedValues.add(currentFilterValue);
          }

          newValue.forEach(item => combinedValues.add(item));
          newFilterValue = Array.from(combinedValues);

          if (newFilterValue.length === 0) {
            newFilterValue = null;
          }

        } else {
          if (Array.isArray(currentFilterValue)) {
            if (currentFilterValue.includes(newValue)) {
              newFilterValue = currentFilterValue.filter(item => item !== newValue);
              if (newFilterValue.length === 0) {
                newFilterValue = null;
              }
            } else {
              newFilterValue = [...currentFilterValue, newValue];
            }
          } else if (currentFilterValue === null) {
            newFilterValue = [newValue];
          } else {
            if (currentFilterValue === newValue) {
              newFilterValue = null;
            } else {
              newFilterValue = [currentFilterValue, newValue];
            }
          }
        }
      } else {
        newFilterValue = newValue;
      }

      return {
        ...activeFilters,
        [filterType]: newFilterValue,
      };
    },
  },
};

export const FilterCalculator = () => {
  const calculateFilterValues = (activeFilters, filterType, newValue, multiselect = false) => {
    const currentFilterValue = activeFilters?.[filterType];
    let newFilterValue;

    if (multiselect) {
      if (newValue === null || (Array.isArray(newValue) && newValue.length === 0)) {
        newFilterValue = null;
      } else if (Array.isArray(newValue)) {
        const combinedValues = new Set();

        if (Array.isArray(currentFilterValue)) {
          currentFilterValue.forEach(item => combinedValues.add(item));
        } else if (currentFilterValue !== null) {
          combinedValues.add(currentFilterValue);
        }

        newValue.forEach(item => combinedValues.add(item));
        newFilterValue = Array.from(combinedValues);

        if (newFilterValue.length === 0) {
          newFilterValue = null;
        }

      } else {
        if (Array.isArray(currentFilterValue)) {
          if (currentFilterValue.includes(newValue)) {
            newFilterValue = currentFilterValue.filter(item => item !== newValue);
            if (newFilterValue.length === 0) {
              newFilterValue = null;
            }
          } else {
            newFilterValue = [...currentFilterValue, newValue];
          }
        } else if (currentFilterValue === null) {
          newFilterValue = [newValue];
        } else {
          if (currentFilterValue === newValue) {
            newFilterValue = null;
          } else {
            newFilterValue = [currentFilterValue, newValue];
          }
        }
      }
    } else {
      newFilterValue = newValue;
    }

    return {
      ...activeFilters,
      [filterType]: newFilterValue,
    };
  };

  return {
    calculateFilterValues,
  };
};
